import { ReactNode, useMemo, useState } from 'react';
import SubscriptionDataContext from '@raas/shared/src/features/subscription/contexts/SubscriptionDataContext';

import type { SubscriptionDataContextContract } from '@raas/shared/src/features/subscription/contexts/SubscriptionDataContext';
import type { SubscriptionContract } from '@raas/shared/src/features/subscription/contracts/subscription.type';

type SubscriptionContextProviderProps = {
  children: ReactNode;
};

export function SubscriptionContextProvider({ children }: SubscriptionContextProviderProps) {
  const [mySubscriptions, setMySubscriptions] = useState<SubscriptionContract[]>([]);
  const [myUserGroupSubscriptions, setMyUserGroupSubscriptions] = useState<SubscriptionContract[]>(
    []
  );
  const [isMyLoading, setIsMyLoading] = useState<boolean>(false);
  const [isMyUserGroupLoading, setIsMyUserGroupLoading] = useState<boolean>(false);

  const dataValue: SubscriptionDataContextContract = useMemo(
    () => ({
      mySubscriptions,
      myUserGroupSubscriptions,
      isMyLoading,
      isMyUserGroupLoading,
      setMySubscriptions,
      setMyUserGroupSubscriptions,
      setIsMyLoading,
      setIsMyUserGroupLoading,
    }),
    [mySubscriptions, myUserGroupSubscriptions, isMyLoading, isMyUserGroupLoading]
  );
  return (
    <SubscriptionDataContext.Provider value={dataValue}>
      {children}
    </SubscriptionDataContext.Provider>
  );
}
